import { Fragment } from "react";
import { NavLink } from "react-router-dom";
import "./Hero.css";
import hero from "../../assets/images/landing/hero.jpg";
import SupervisorAccountIcon from "@mui/icons-material/SupervisorAccount";
import InsertChartIcon from "@mui/icons-material/InsertChart";
import DoneIcon from "@mui/icons-material/Done";

const Hero = () => {
  return (
    <Fragment>
      <section className="hero-style">
        <div className="container">
          <div className="row">
            <div className="col-xxl-6 col-lg-6 col-md-12 col-sm-6">
              <div className="hero-content">
                <span className="hero-badge" data-aos="fade-down-right">
                  Trusted by 250+ Companies
                </span>
                <h2
                  className="hero-title text-capitalize"
                  data-aos="fade-up-right"
                  data-aos-delay="200"
                  data-aos-duration="1000"
                >
                  Expand Your Digital World With Our 
                    
                  <span className="title-gradient"> Web 3.0</span> Expertise
                </h2>
                <p
                  className="hero-subtitle f-15"
                  data-aos="fade-up-right"
                  data-aos-delay="500"
                  data-aos-duration="1500"
                >
                  We are the leading Web 3.0 development company actively
                  engaged in the creation of mobile and web applications as well
                  as upcoming technologies.
                </p>
                <div className="mt-35">
                  <div
                    className="hero-btn-fill"
                    data-aos="fade-up"
                    data-aos-delay="700"
                    data-aos-duration="1700"
                  >
                    <NavLink to="/contact">
                      <span>Get a Quotes</span>
                    </NavLink>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-xxl-6 col-lg-6 col-md-12 col-sm-6">
              <div className="hero-image">
                <div data-aos="fade-up-left" data-aos-duration="1300">
                  <img src={hero} loading="lazy" alt="image not found" className="img-fluid" />
                </div>
                <div className="floating-card card-1" data-aos="zoom-in">
                  <div className="card-icon">
                    <SupervisorAccountIcon />
                  </div>
                  <div className="d-flex flex-column">
                    <span className="card-value">20k+</span>
                    <span className="card-label">Clients Review</span>
                  </div>
                </div>
                <div className="floating-card card-2" data-aos="zoom-in">
                  <div className="card-icon">
                    <InsertChartIcon />
                  </div>
                  <div className="d-flex flex-column">
                    <span className="card-value">100k+</span>
                    <span className="card-label">Projects</span>
                  </div>
                </div>
                <div className="floating-card card-3" data-aos="zoom-in">
                  <div className="card-icon">
                    <DoneIcon />
                  </div>
                  <div className="d-flex flex-column">
                    <span className="card-label">Successful Deployment</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </Fragment>
  );
};
export default Hero;
